<script lang="ts">
	import { slideIn } from '$lib/actions/slideIn';
	import WreathLeft from '$lib/icons/wreathLeft.svelte';
	import WreathRight from '$lib/icons/wreathRight.svelte';
	import Image from '$lib/storyblok/components/image.svelte';
	import { editable } from '$lib/storyblok/editable';
	import type { SbImage, SbLink } from '$lib/storyblok/types';
	import TwoLineText from '$lib/twoLineText.svelte';
	import { getSbUrl } from '$lib/utils/storyblok/url';
	import type { ISbStoryData } from '@storyblok/js';
	import type { CardCategory } from './types';

	interface Props {
		content: ISbStoryData<{
			logo: SbImage;
			link: SbLink;
			title: string;
			category: CardCategory;
		}>['content'];
		delay?: number;
		threshold?: number;
	}

	let { content, delay = 300, threshold = 0.3 }: Props = $props();
</script>

<a
	use:editable={content}
	use:slideIn={{ delay, threshold }}
	href={getSbUrl(content.link)}
	target={content.link?.target}
	class="flex w-full flex-col items-center gap-y-3 rounded-xl bg-[#202020] py-4 opacity-[0.01] lg:gap-y-6 lg:py-9"
>
	<Image
		src={content.logo?.filename}
		alt={content.logo?.alt}
		title={content.logo?.title}
		class="h-4 w-full md:h-6"
		height={16}
		sizes={{ 768: { height: 24 } }}
	/>

	<div class="flex items-center justify-around">
		<WreathLeft class="ml-2 h-full min-w-6 flex-1 lg:min-w-8 xl:min-w-10" />
		<div class="flex flex-col items-center justify-center gap-y-[5px] text-white">
			<div class="eyebrow text-[12px]/[100%] font-semibold uppercase tracking-[.96px] opacity-60">
				Winner
			</div>
			<div
				class="text-center text-[14px]/[112%] tracking-[-.14px] md:text-[16px]/[120%] md:tracking-[-.16px] xl:text-[20px]/[130%] xl:tracking-[-.2px] 2xl:text-[24px]/[140%] 2xl:tracking-[-.24px]"
			>
				<TwoLineText text={content.title} />
			</div>
		</div>
		<WreathRight class="mr-2 h-full min-w-6 flex-1 lg:min-w-8 xl:min-w-10" />
	</div>
</a>

<style>
	a {
		box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.02);
	}

	@media (max-width: 1023px) {
		div.eyebrow {
			text-shadow: 0px 0px 33.374px rgba(13, 13, 5, 0.2);
		}
	}
</style>
